import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useThemeStore } from '../stores/themeStore';
import Icons from './icons';


interface ThemeToggleButtonProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'inherit' | 'primary' | 'secondary' | 'default';
}

const ThemeToggleButton: React.FC<ThemeToggleButtonProps> = ({ 
  size = 'medium', 
  color = 'inherit' 
}) => {
  const { mode, toggleTheme } = useThemeStore();

  const handleToggle = () => {
    console.log('[ThemeToggleButton] Toggling from', mode, 'to', mode === 'light' ? 'dark' : 'light');
    toggleTheme();
  };

  return (
    <Tooltip title={`Cambiar a modo ${mode === 'light' ? 'oscuro' : 'claro'}`}>
      <IconButton
        onClick={handleToggle}
        color={color}
        size={size}
        aria-label="cambiar tema"
        disableRipple
        disableFocusRipple
        disableTouchRipple
        sx={{
          '& .icons-light, & .icons-dark': {
            fontSize: '22px',
            color: 'text.primary'
          }
        }}
      >
        {mode === 'light' ? <Icons className="icons-light" /> : <Icons className="icons-dark" />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggleButton; 